export const selectTotalValueByStageData = (state) => state.proposals.totalValueByStage.data;
export const selectTotalValueByStageLoading = (state) => state.proposals.totalValueByStage.isLoading;
export const selectTotalValueByStageError = (state) => state.proposals.totalValueByStage.error;
